<template>
  <div>
    <Charge ref="Charge"></Charge>
  </div>
</template>

<script>
import CommonMixin from "@/mixins/CommonMixin.js";
import Charge from "@/components/membership/service/modal/Charge.vue";

export default {
  data: () => ({}),
  methods: {
    moveIntro: function() {
      let route = this.$router.resolve({
        path: `/authservice/${this.$store.state.mallId}/serviceIntro`,
      });
      window.open(route.href, "_blank");
    },
  },
  mixins: [CommonMixin],
  components: {
    Charge,
  },
  created: function() {},
  mounted: function() {
    this.$refs.Charge.show();
  },
};
</script>
